import React from "react";
import ReactGA from "react-ga";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import storyCar from "../../images/homepage/storyCar.jpg";
import title from "../../images/homepage/story-title-2.png"

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: auto;
  position: relative;
`;

const Left = styled.div`
  width: 51.38888%;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;

const Title = styled.h2`
  font-weight: bold;
  font-size: 48px;
  line-height: 71px;
  letter-spacing: 0.1rem;
  color: #30251D;
  padding: 0px 130px;
  margin-bottom: 20px;
  @media screen and (min-width: 767px) {
    display: flex;
    align-items: flex-end;
  }
  p {
    img {
      max-width: 90%;
      /* @media screen and (max-width: 767px) {

      } */
    }
  }
  /* &::after {
    content: '';
    width: 40px;
    height: 1px;
    background-color: #30251D;
    display: inline-block;
    margin-left: 20px;
    @media screen and (max-width: 1024px) {
      display: block;
      margin-left: 0px;
      margin: auto;
      margin-top: 20px;
    }
  } */
  @media screen and (max-width: 1300px) {
    padding: 0px 60px;
  }
  @media screen and (max-width: 1024px) {
    text-align: center;
    p {
      img {
        /* max-width: 200px; */
      }
    }
  }
`;

const TextContainer = styled.div`
  width: 100%;
  margin: auto;
  background: #30251D;
  padding: 40px 160px 40px 130px;
  @media screen and (max-width: 1300px) {
    padding: 40px 160px 40px 60px;
  }
  @media screen and (max-width: 1024px) {
    padding: 40px;
  }
`;

const H3 = styled.h3`
  font-weight: 500;
  font-size: 26px;
  letter-spacing: 0.1rem;
  color: #FFFFFF;
  margin-bottom: 40px;
  @media screen and (max-width: 767px) {
    font-size: 24px;
  }
`;

const Text = styled.p`
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  text-align: justify;
  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;

const More = styled.div`
  position: relative;
  width: 45%;
  border: 1px solid #FFF;
  padding: 8px 10px 8px 20px;
  margin-top: 50px;
  a {
    font-size: 18px;
    text-align: left;
    letter-spacing: 0.1rem;
    color: #FFF;
    display: block;
  }
  &::after {
    content: '';
    width: 50px;
    height: 1px;
    display: block;
    background-color: #FFF;
    position: absolute;
    top: 50%;
    right: -30px;
  }
  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;

const Right = styled.div`
  width: 56.38888%;
  position: absolute;
  top: 0;
  right: 0;
  img {
    width: 100%;
  }
  @media screen and (max-width: 1024px) {
    width: 100%;
    position: relative;
  }
`;



const HomeCase = () => {
  return (
    <Container>
      <Left>
        <Title>
          <p>
            <img src={title} alt=""/>
          </p>
          品牌故事
        </Title>
        <TextContainer>
          <H3>全球最受愛戴的4WD</H3>
          <Text>
            自首次亮相以來已有60多年的歷史。
            <br />
            <br />
            LAND CRUISER 是TOYOTA歷史最悠久的車系也是世界上許多人喜愛的四驅車。特別是在沙漠地形佔該國大部分地區的中東，市占率很高。
            <br />
            <br />
            對於警察和邊防人員而言，它是執行重要任務不可或缺的夥伴。
          </Text>
          <More>
              <Link to={"/story/"} onClick={()=>{
                ReactGA.event({
                  category: "202012_PRADO",
                  action: "Click",
                  label: `HomePageStory-品牌故事`,
                });
              }}>MORE</Link>
          </More>
        </TextContainer>
      </Left>
      <Right>
        <img src={storyCar} alt=""/>
      </Right>
    </Container>
  )
};

export default HomeCase;